import React from 'react';
import {
  Dashboard as DashboardIcon,
  Gavel as GavelIcon,
  Business as BusinessIcon,
  Settings as SettingsIcon,
  ShoppingCart as StorefrontIcon,
  People as PeopleIcon,
  LocalShipping as ShippingIcon,
  Route as DirectionsCarIcon,
  Handshake as HandshakeIcon,
  Badge as DriversIcon,
  Caravan as VehiclesIcon,
  LocationOn as FleetMapIcon,
} from '../../ui/icons';

export const menuItems = [
  {
    label: 'menu.dashboard',
    icon: <DashboardIcon />,
    path: '/dashboard',
  },
  {
    label: 'menu.freights',
    icon: <ShippingIcon />,
    path: '/freights',
  },
  {
    label: 'menu.exchange',
    icon: <StorefrontIcon />,
    path: '/exchange',
  },
  {
    label: 'menu.my_bids',
    icon: <HandshakeIcon />,
    path: '/bids',
  },
  {
    label: 'menu.tender',
    icon: <GavelIcon />,
    path: '/tender',
  },
  {
    label: 'menu.fleet',
    icon: <DirectionsCarIcon />,
    path: '/fleet',
  },
  {
    label: 'menu.drivers',
    icon: <DriversIcon />,
    path: '/drivers',
  },
  {
    label: 'menu.vehicles',
    icon: <VehiclesIcon />,
    path: '/vehicles',
  },
  {
    label: 'menu.fleet_map',
    icon: <FleetMapIcon />,
    path: '/fleet-map',
  },
  {
    label: 'menu.companies',
    icon: <BusinessIcon />,
    path: '/companies',
  },
  {
    label: 'menu.team',
    icon: <PeopleIcon />,
    path: '/team',
  },
  {
    label: 'menu.settings',
    icon: <SettingsIcon />,
    path: '/settings',
  },
];
